import { render } from "./RatingModal.vue?vue&type=template&id=1d09edb3&scoped=true"
import script from "./RatingModal.vue?vue&type=script&lang=js"
export * from "./RatingModal.vue?vue&type=script&lang=js"

import "./RatingModal.vue?vue&type=style&index=0&id=1d09edb3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d09edb3"]])

export default __exports__